import script from "./DefBreadCrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefBreadCrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./DefBreadCrumbs.vue?vue&type=style&index=0&id=a4411328&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4411328"]])

export default __exports__